import { render, staticRenderFns } from "./ManagementFeeAdd.vue?vue&type=template&id=9b07998c&scoped=true"
import script from "./ManagementFeeAdd.vue?vue&type=script&lang=js"
export * from "./ManagementFeeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b07998c",
  null
  
)

export default component.exports